import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    arrow:
      'text-main absolute top-1/2 hidden -translate-y-1/2 transform cursor-pointer p-0 lg:block'
  }
});
